import { Component, OnInit, Inject } from '@angular/core';
import { PhysicianService } from '../../../services/physician.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { FilterCompleteService } from '../../../filter-complete/filter-complete';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidateAutoCompleteSelect } from '../../../validators/autocomplete-select.validator';

@Component({
  selector: 'physician-replacement-dialog',
  templateUrl: 'physician-replacement-dialog.component.html',
  styleUrls: ['./physician-replacement-dialog.component.css']
})
export class PhysicianReplacementDialogComponent implements OnInit {

  loading: boolean;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  existsPhysicians: boolean;
  form: FormGroup;

  constructor(private physicianService: PhysicianService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<PhysicianReplacementDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      Physician: ['', [Validators.required, ValidateAutoCompleteSelect]]
    });

    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>([], this.form.controls.Physician);
  }

  get filteredPhysiciansOptions() { return this.filterCompletePhysicians ? this.filterCompletePhysicians.filteredOptions : []; }
  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.loading = true;
        await this.physicianService.replacementMedicalApponitmentPhysician({
          MedicalAppointmentId: this.data.medicalAppointmentId
          , PhysicianId : (<PhysicianFilter>this.form.getRawValue().Physician).Id
        });
        this.notificationToastService.success('Se ha reemplazado el médico correctamente', 'Reemplazo de médico');
        this.dialogRef.close(false);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Reemplazo de médico');
    } finally {
      this.loading = false;
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      const physiciansFilter = await this.physicianService.getReplacementPhysicianFilters(this.data.medicalAppointmentId);
      this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.Physician);
      this.form.patchValue({ Physician: null });
      this.existsPhysicians = physiciansFilter.length > 0;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Reemplazo de médico');
    } finally {
      this.loading = false;
    }
  }
}
